import { Controller } from "@hotwired/stimulus"

// Contrôleur racine du runtime quiz. Coordonne l'UI du quiz en cours (timer, saisie réponses, etc.).
// Les Turbo Streams (broadcast depuis les transitions d'état de Quiz::Run) gèrent les rafraîchissements
// de stage automatiquement — ce contrôleur gère principalement l'état UI local.
export default class extends Controller {
  static values = {
    runId: Number,
    state: String,
    currentIndex: Number,
    role: String
  }
  static targets = ["stage"]

  connect() {
    // No-op pour l'instant. Futur : pourrait écouter les broadcasts quiz_run:* via ActionCable
    // pour des mises à jour UI plus fines au-delà des remplacements Turbo Streams.
  }
}
